import { get } from "lodash";
import {
  // getAccessTokenInfo,
  getCompanyTokenInfo
} from "../apis/auth";
import { isAdmin } from "./auth";
import { dps, isEmpty } from "./lodashExtend";

// TAX CONSULTING 읽을 수 있는 지
// 세부 체크 및 세부 기능 필요
// 서버에서 사용 가능한 카테고리만 호출되도록 변경
export const isTaxConsultingReading = (consulting = { accesses: [] }) => {
  const companyInfo = getCompanyTokenInfo();
  if (consulting.visibility !== "restricted") return true;
  if (isAdmin()) return true;
  return !!consulting.managers?.find(f => f.employeeIdx === companyInfo.employeeIdx) || !!consulting.accesses?.find(f => f.employeeIdx === companyInfo.employeeIdx);
};

// TAX CONSULTING 의 관리자인지 체크
// 세부 체크 및 세부 기능 필요
// isAdmin, isWrite, isDelete, isPersonalView
export const isTaxConsultingManager = (consulting = { managers: [] }, roleType = "") => {
  const companyInfo = getCompanyTokenInfo();
  const myManager = consulting.managers?.find(f => f.employeeIdx === companyInfo.employeeIdx);
  return isAdmin() || (roleType === "" ? !!myManager : get(myManager, roleType, false));
};

// role = "WRITE", "READ" , "READ_LIST"
export const isBoardRole = (content = { accesses: [], managers: [] }, role = "WRITE") => {
  const { employeeIdx } = getCompanyTokenInfo();
  const companyInfo = getCompanyTokenInfo();
  const myManager = content.managers?.find(f => f.employeeIdx === companyInfo.employeeIdx);
  return myManager || (content.role === role ||
    content?.accesses?.find(f => f.employeeIdx === employeeIdx)?.role === role);
};

// category 
export const findCategoryManager = (categories, targetIdx) => {
  const data = dps(categories, targetIdx, 'childCategories');
  if (!isEmpty(data?.manager) || data?.parentCategoryIdx === null) {
    return data?.manager;
  } else {
    if (data?.parentCategoryIdx) {
      return findCategoryManager(categories, data.parentCategoryIdx);
    } else {
      return {};
    }
  }
};